import { render, staticRenderFns } from "./PayRiskManagement.vue?vue&type=template&id=155f9cd8&"
import script from "./PayRiskManagement.vue?vue&type=script&lang=js&"
export * from "./PayRiskManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports